// extracted by mini-css-extract-plugin
module.exports = {"centered":"ActionsHandler_centered__pJCoj","dotsContainer":"ActionsHandler_dotsContainer__Hmrue"};